<template>
	<v-container>
		<v-row>
			<v-col class="text-center" cols="12">
				<div class="headline primary--text">TeleRetina - Stages &amp; States</div>
			</v-col>

			<v-col cols="12">
				<v-card>
					<v-card-title primary-title>
						Stages
						<v-spacer></v-spacer>
						<v-btn text icon color="primary" @click="showAddStage">
							<v-icon>mdi-plus</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text class="pb-0">
						<v-data-table
							:headers="stagesHeaders"
							:items="stages"
							hide-default-footer
							:loading="stagesLoading"
						>
							<template v-slot:item.actions="{ item }">
								<span v-if="item.id" style="white-space: nowrap;">
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-icon color="primary" v-on="on" @click="showModifyStage(item)">mdi-pen</v-icon>
										</template>

										<span>Edit</span>
									</v-tooltip>

									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-icon color="red" v-on="on" @click="deleteStage(item)">mdi-delete</v-icon>
										</template>

										<span>Delete</span>
									</v-tooltip>
								</span>
							</template>
						</v-data-table>
					</v-card-text>
					<v-card-actions v-if="stagesLength">
						<v-col cols="12" class="pa-0 text-center">
							<v-pagination
								v-model="stagesPage"
								:length="stagesLength"
								:disabled="false"
								circle
								color="primary"
							></v-pagination>
						</v-col>
					</v-card-actions>
				</v-card>
			</v-col>

			<v-col cols="12">
				<v-card>
					<v-card-title primary-title>
						States
						<v-spacer></v-spacer>
						<v-btn text icon color="primary" @click="showAddState">
							<v-icon>mdi-plus</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text class="pb-0">
						<v-data-table
							:headers="statesHeaders"
							:items="states"
							hide-default-footer
							:loading="statesLoading"
						>
							<template v-slot:item.actions="{ item }">
								<span v-if="item.id" style="white-space: nowrap;">
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-icon color="primary" v-on="on" @click="showModifyState(item)">mdi-pen</v-icon>
										</template>

										<span>Edit</span>
									</v-tooltip>

									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-icon color="red" v-on="on" @click="deleteState(item)">mdi-delete</v-icon>
										</template>

										<span>Delete</span>
									</v-tooltip>
								</span>
							</template>
						</v-data-table>
					</v-card-text>
					<v-card-actions v-if="statesLength">
						<v-col cols="12" class="pa-0 text-center">
							<v-pagination
								v-model="statesPage"
								:length="statesLength"
								:disabled="false"
								circle
								color="primary"
							></v-pagination>
						</v-col>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>

		<v-dialog v-model="addStageDialog" persistent width="290px">
			<v-card>
				<v-card-title>
					<span class="headline">Add new Stage</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-form v-model="valid">
							<v-row dense>
								<v-col cols="12">
									<v-text-field v-model="newStageDesc" label="Description" :rules="[rules.required]"></v-text-field>
								</v-col>
								<v-col cols="12">
									<v-text-field v-model="newStagePrev" label="Previous Stage"></v-text-field>
								</v-col>
							</v-row>
						</v-form>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="error"
						class="text-none"
						text
						:disabled="loading"
						@click.native="addStageDialog = false"
					>
						<template>Close</template>
					</v-btn>
					<v-btn
						color="primary"
						class="text-none"
						:disabled="!valid || loading"
						:loading="loading"
						@click.native="addStage"
					>
						<template>Add</template>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="addStateDialog" persistent width="290px">
			<v-card>
				<v-card-title>
					<span class="headline">Add new State</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-form v-model="valid">
							<v-row dense>
								<v-col cols="12">
									<v-text-field v-model="newStateDesc" label="Description" :rules="[rules.required]"></v-text-field>
								</v-col>
							</v-row>
						</v-form>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="error"
						class="text-none"
						text
						:disabled="loading"
						@click.native="addStateDialog = false"
					>
						<template>Close</template>
					</v-btn>
					<v-btn
						color="primary"
						class="text-none"
						:disabled="!valid || loading"
						:loading="loading"
						@click.native="addState"
					>
						<template>Add</template>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="modifyStageDialog" width="290px">
			<v-card>
				<v-card-title>
					<span class="headline">Modify Stage</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-form v-model="valid">
							<v-row dense>
								<v-col cols="12">
									<v-text-field v-model="modifyStageDesc" label="Description" :rules="[rules.required]"></v-text-field>
								</v-col>
								<v-col cols="12">
									<v-text-field v-model="modifyStagePrev" label="Previous Stage"></v-text-field>
								</v-col>
							</v-row>
						</v-form>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="error"
						class="text-none"
						text
						:disabled="loading"
						@click.native="modifyStageDialog = false"
					>
						<template>Close</template>
					</v-btn>
					<v-btn
						color="primary"
						class="text-none"
						:disabled="!valid || loading"
						:loading="loading"
						@click.native="modifyStage"
					>
						<template>Modify</template>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="modifyStateDialog" width="290px">
			<v-card>
				<v-card-title>
					<span class="headline">Modify State</span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-form v-model="valid">
							<v-row dense>
								<v-col cols="12">
									<v-text-field v-model="modifyStateDesc" label="Description" :rules="[rules.required]"></v-text-field>
								</v-col>
							</v-row>
						</v-form>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="error"
						class="text-none"
						text
						:disabled="loading"
						@click.native="modifyStateDialog = false"
					>
						<template>Close</template>
					</v-btn>
					<v-btn
						color="primary"
						class="text-none"
						:disabled="!valid || loading"
						:loading="loading"
						@click.native="modifyState"
					>
						<template>Modify</template>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
const axios = require("axios");

export default {
	mixins: [
		require("@/mixins/backend-mixin").default,
		require("@/mixins/router-mixin").default,
		require("@/mixins/rules-mixin").default
	],
	data() {
		return {
			stagesHeaders: [
				{
					text: "#",
					align: "left",
					value: "id",
					sortable: false
				},
				{
					text: "Description",
					align: "left",
					value: "description",
					sortable: false
				},
				{
					text: "Previous Stage",
					align: "left",
					value: "previousStage",
					sortable: false
				},
				{
					text: "Actions",
					align: "center",
					value: "actions",
					sortable: false
				}
			],
			statesHeaders: [
				{
					text: "#",
					align: "left",
					value: "id",
					sortable: false
				},
				{
					text: "Description",
					align: "left",
					value: "description",
					sortable: false
				},
				{
					text: "Actions",
					align: "center",
					value: "actions",
					sortable: false
				}
			],
			states: [],
			stages: [],
			statesPage: 1,
			stagesPage: 1,
			stagesLength: 1,
			statesLength: 1,
			addStageDialog: false,
			newStageDesc: null,
			newStagePrev: null,
			addStateDialog: false,
			newStateDesc: null,
			loading: false,
			valid: false,
			statesLoading: true,
			stagesLoading: true,
			modifyStageDialog: false,
			modifyStateDialog: false,
			modifyStageDesc: null,
			modifyStagePrev: null,
			modifyStateDesc: null,
			modifiyId: null
		};
	},
	mounted() {
		this.getData();
	},
	methods: {
		getData() {
			this.getStates();
			this.getStages();
		},
		getStates() {
			const url = this.BACKEND_URL + "/api/allStates";
			const thisVue = this;

			axios
				.get(url)
				.then(response => {
					if (response.status == 200) {
						thisVue.states = response.data.data;
						thisVue.statesLoading = false;
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		getStages() {
			const url = this.BACKEND_URL + "/api/allStages";
			const thisVue = this;

			axios
				.get(url)
				.then(response => {
					if (response.status == 200) {
						thisVue.stages = response.data.data;
						thisVue.stagesLoading = false;
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		deleteState(state) {
			var token = this.getBackendToken();

			const url =
				this.BACKEND_URL +
				"/api/deleteState/" +
				state.id +
				"?token=" +
				token;
			const thisVue = this;

			axios
				.get(url)
				.then(response => {
					if (response.status == 200) {
						console.log(response);

						var index = thisVue.states.indexOf(state);
						thisVue.states.splice(index, 1);

						thisVue.$store.dispatch("triggerPushNotification", {
							message: "State deleted"
						});
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		deleteStage(stage) {
			var token = this.getBackendToken();

			const url =
				this.BACKEND_URL +
				"/api/deleteStage/" +
				stage.id +
				"?token=" +
				token;
			const thisVue = this;

			axios
				.get(url)
				.then(response => {
					if (response.status == 200) {
						console.log(response);

						var index = thisVue.stages.indexOf(stage);
						thisVue.stages.splice(index, 1);

						thisVue.$store.dispatch("triggerPushNotification", {
							message: "Stage deleted"
						});
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		modifyStage() {
			this.loading = true;

			const url = this.BACKEND_URL + "/api/updateStage";
			const thisVue = this;
			var token = this.getBackendToken();

			var data = {
				id: this.modifiyId,
				description: this.modifyStageDesc,
				previousStage: this.modifyStagePrev,
				token: token
			};

			axios
				.post(url, data)
				.then(response => {
					if (response.status == 200) {
						var stage = thisVue.stages.filter(
							stage => this.modifiyId == stage.id
						)[0];
						var index = thisVue.stages.indexOf(stage);

						thisVue.stages[index].description =
							response.data.description;
						thisVue.stages[index].previousStage =
							response.data.previousStage;

						this.loading = false;
						thisVue.modifyStageDialog = false;

						thisVue.$store.dispatch("triggerPushNotification", {
							message: "Stage modified"
						});
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		modifyState() {
			this.loading = true;

			const url = this.BACKEND_URL + "/api/updateState";
			const thisVue = this;

			var token = this.getBackendToken();

			var data = {
				id: this.modifiyId,
				description: this.modifyStateDesc,
				token: token
			};

			axios
				.post(url, data)
				.then(response => {
					if (response.status == 200) {
						var state = thisVue.states.filter(
							state => this.modifiyId == state.id
						)[0];
						var index = thisVue.states.indexOf(state);

						thisVue.states[index].description =
							response.data.description;

						this.loading = false;
						thisVue.modifyStateDialog = false;

						thisVue.$store.dispatch("triggerPushNotification", {
							message: "State modified"
						});
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		showAddStage() {
			this.addStageDialog = true;
		},
		showAddState() {
			this.addStateDialog = true;
		},
		showModifyStage(item) {
			this.modifiyId = item.id;
			this.modifyStageDesc = item.description;
			this.modifyStagePrev = item.previousStage;
			this.modifyStageDialog = true;
		},
		showModifyState(item) {
			this.modifiyId = item.id;
			this.modifyStateDesc = item.description;
			this.modifyStateDialog = true;
		},
		addStage() {
			this.loading = true;

			const url = this.BACKEND_URL + "/api/createStage";
			const thisVue = this;

			var token = this.getBackendToken();

			var data = {
				description: this.newStageDesc,
				previousStage: this.newStagePrev,
				token: token
			};

			axios
				.post(url, data)
				.then(response => {
					if (response.status == 200) {
						thisVue.stages.push(response.data);

						this.loading = false;
						thisVue.addStageDialog = false;

						thisVue.$store.dispatch("triggerPushNotification", {
							message: "Stage added"
						});
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		addState() {
			this.loading = true;

			const url = this.BACKEND_URL + "/api/createState";
			const thisVue = this;

			var token = this.getBackendToken();

			var data = {
				description: this.newStateDesc,
				token: token
			};

			axios
				.post(url, data)
				.then(response => {
					if (response.status == 200) {
						thisVue.states.push(response.data);

						this.loading = false;
						thisVue.addStateDialog = false;

						thisVue.$store.dispatch("triggerPushNotification", {
							message: "State added"
						});
					}
				})
				.catch(error => {
					console.error(error);
				});
		}
	}
};
</script>